import socket from '../../../socketio/socketio.js'

// Public return portal events, see server/socketio/returnPortalIO.ts
function request(event, ...args) {
    return new Promise((resolve, reject) => {
        socket.emit(event, ...args, (err, result) => {
            if (err) {
                reject(new Error(err))
            } else {
                resolve(result)
            }
        })
    })
}

export default {
    getPortal: (customerURL) => request('returnPortal.getPortal', customerURL),

    // Resolves to {returnParcel} when a return parcel exists, otherwise {returnParcelRequest, options}
    find: (customerURL, orderNumberOrTrackTrace, postalCode) => request('returnPortal.find', customerURL, orderNumberOrTrackTrace, postalCode),

    // Resolves to the created return parcel
    submit: (customerURL, returnParcelRequest) => request('returnPortal.submit', customerURL, returnParcelRequest),

    // Resolves to {checkoutLink}
    createPayment: (customerURL, orderNumberOrTrackTrace, postalCode) => request('returnPortal.createPayment', customerURL, orderNumberOrTrackTrace, postalCode)
}
